<template>
  <el-dialog
    v-model="dialogVisible"
    title="设置"
    width="500px"
  >
    <el-form label-position="top">
      <el-form-item label="存储模式">
        <el-radio-group v-model="storageMode" @change="handleModeChange">
          <el-radio value="indexeddb">IndexedDB（默认）</el-radio>
          <el-radio value="file">本地文件</el-radio>
        </el-radio-group>
        <div class="mode-description">
          <el-alert
            v-if="storageMode === 'indexeddb'"
            title="数据存储在浏览器 IndexedDB 中，刷新页面后数据不会丢失"
            type="info"
            :closable="false"
          />
          <el-alert
            v-else
            title="数据存储在本地文件中，需要选择工作目录"
            type="warning"
            :closable="false"
          />
        </div>
      </el-form-item>

      <el-divider />

      <el-form-item label="数据管理">
        <div class="data-actions">
          <el-button type="primary" @click="handleExportData">
            <el-icon><Upload /></el-icon>
            导出数据
          </el-button>
          <el-button @click="handleImportData">
            <el-icon><Download /></el-icon>
            导入数据
          </el-button>
          <el-button type="danger" @click="handleClearData">
            <el-icon><Delete /></el-icon>
            清空数据
          </el-button>
        </div>
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button @click="dialogVisible = false">关闭</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, watch } from 'vue'
import { ElMessageBox } from 'element-plus'

// eslint-disable-next-line no-undef
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  mode: {
    type: String,
    default: 'indexeddb'
  }
})

// eslint-disable-next-line no-undef
const emit = defineEmits(['update:modelValue', 'update:mode', 'export-data', 'import-data', 'clear-data'])

const dialogVisible = ref(props.modelValue)
const storageMode = ref(props.mode)

watch(() => props.modelValue, (val) => {
  dialogVisible.value = val
})

watch(() => dialogVisible.value, (val) => {
  emit('update:modelValue', val)
})

watch(() => props.mode, (val) => {
  storageMode.value = val
})

const handleModeChange = (val) => {
  storageMode.value = val
  emit('update:mode', val)
}

const handleExportData = () => {
  emit('export-data')
}

const handleImportData = () => {
  const input = document.createElement('input')
  input.type = 'file'
  input.accept = '.json'
  input.onchange = (e) => {
    const file = e.target.files[0]
    if (file) {
      emit('import-data', file)
    }
  }
  input.click()
}

const handleClearData = () => {
  ElMessageBox.confirm(
    '确定要清空所有数据吗？此操作不可恢复！',
    '警告',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }
  ).then(() => {
    emit('clear-data')
  }).catch(() => {
    // 取消操作
  })
}
</script>

<style scoped>
.mode-description {
  margin-top: 12px;
}

.data-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
</style>
